<wlm-popup-wrapper
  [titleKey]="titleKey"
  [showCloseButton]="false"
  [showCancelButton]="true"
  (popupClose)="cancel($event)"
>
  <ng-container popup-content>
    <wlm-create-dashboard-form
      (dashboardChange)="onDashboardChange($event)"
      (isValidChange)="onValidChange($event)"
    ></wlm-create-dashboard-form>
  </ng-container>

  <ng-container popup-actions>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!isValid">
      {{ 'common.save' | translate }}
    </button>
  </ng-container>
</wlm-popup-wrapper>
